<form>
    <div class="position-relative w-100">
        <input
            class="form-control"
            [value]="displayText"
            placeholder="dd-mm - dd-mm"
            readonly
            (click)="dp.toggle()"
        />

        <input
            class="position-absolute top-0 start-0 opacity-0 pe-none"
            ngbDatepicker
            #dp="ngbDatepicker"
            [placement]="placement"
            [autoClose]="'outside'"
            [startDate]="startDate"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [displayMonths]="1"
            [dayTemplate]="t"
            outsideDays="hidden"
            (dateSelect)="onDateSelection($event)"
        />
    </div>
</form>

<ng-template #t let-date let-focused="focused">
    <span
        class="d-flex align-items-center justify-content-center w-100 h-100 rounded"
        [class.bg-light]="focused && !isRange(date) && hoveredDate !== date"
        [class.bg-primary]="(isRange(date) && !isInside(date) && !isHovered(date)) || hoveredDate === date"
        [class.text-white]="(isRange(date) && !isInside(date) && !isHovered(date)) || hoveredDate === date"
        [class.bg-primary-subtle]="(isInside(date) || isHovered(date)) && hoveredDate !== date"
        (mouseenter)="hoveredDate = date"
        (mouseleave)="hoveredDate = null"
    >
        {{ date.day }}
    </span>
</ng-template>
